import { AccessHandlerEntitlementsTranslation } from 'locales/de/pages/Access-Handler/entitlements';

const en: AccessHandlerEntitlementsTranslation = {
  title: 'Entitlements',
  create: 'Create Entitlement',
  tableHeader: {
    entitlement: 'Entitlement',
    entitlementGroup: 'Entitlementgroup'
  },
  model: {
    name: 'Rolename',
    entitlementGroups: 'Entitlementgroups',
    permissions: 'Permissions'
  },
  modal: {
    included: 'Included',
    notIncluded: 'Not included'
  },
  deleteConfirm: {
    title: 'Really delete?',
    message: 'Do you really want to delete this role?'
  },
  alerts: {
    errorLoading: 'The roles could not be loaded.',
    saveFailed: 'The role could not be saved.',
    saveSuccess: 'The role has been saved.',
    deleteFailed: 'The role could not be deleted.',
    deleteSuccess: 'The role has been deleted.'
  }
};

export default en;
